import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    width: 180,
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  itemContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 4,
  },
  labelContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginLeft: 4,
  },
  label: {
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 8,
  },
  button: {
    width: 172,
    borderRadius: 8,
    fontSize: 14,
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 8,
  },
  confirmText: {
    fontSize: 14,
    textAlign: 'center',
    textTransform: 'uppercase',
    color: '#333333',
    lineHeight: 1.2,
    marginBottom: 8,
  },
}));
